'use client';

import { startTransition, useCallback, useMemo } from 'react';
import { useLocalStorage } from './useLocalStorage';

const RECENT_TICKERS_KEY = 'recentQuotes';
const MAX_RECENT_TICKERS = 7;

export const useRecentTickers = (maxTickers: number = MAX_RECENT_TICKERS): [string[], (ticker: string) => void] => {
  const [recentTickers, setRecentTickers] = useLocalStorage<string[]>(RECENT_TICKERS_KEY, []);

  const addRecentTicker = useCallback(
    (ticker: string) => {
      if (!ticker) return;

      startTransition(() => {
        setRecentTickers(currentTickers => {
          const updatedTickers = [...currentTickers];
          const existingIndex = updatedTickers.indexOf(ticker);

          if (existingIndex !== -1) {
            updatedTickers.splice(existingIndex, 1);
          }

          updatedTickers.unshift(ticker);

          return updatedTickers.slice(0, maxTickers);
        });
      });
    },
    [setRecentTickers, maxTickers],
  );

  const memoizedTickers = useMemo(() => recentTickers.slice(0, maxTickers), [recentTickers, maxTickers]);

  return [memoizedTickers, addRecentTicker];
};

export default useRecentTickers;
